import { FC } from 'react';
import UnifiedSettingsContainer from '../Components/Settings/UnifiedSettingsContainer';

export const PageSettings: FC = () => {
    return <UnifiedSettingsContainer />;
};
